import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";
import { requestNotificationPermission, getNotificationPermissionStatus } from "../../utils/notificationService";
import { requestFirebaseToken } from "../../utils/firebase";
import { saveFcmDeviceToken } from "../../utils/apis/user";
import "./NotificationPrompt.scss";

const NotificationPrompt = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { isAuthenticated, idToken } = useSelector((state) => state?.auth);

    useEffect(() => {
        // Only show for authenticated users
        if (!isAuthenticated) return;

        const askedBefore = localStorage.getItem("notification-prompt-shown");
        const permissionStatus = getNotificationPermissionStatus();

        if (!askedBefore && permissionStatus === "default") {
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [isAuthenticated]);

    const handleAllow = async () => {
        // Close our modal first
        setIsVisible(false);
        localStorage.setItem("notification-prompt-shown", "true");

        // Then request browser permission
        const granted = await requestNotificationPermission();

        if (granted) {
            // Immediately trigger registration now that we have a user gesture
            requestFirebaseToken().then((token) => {
                if (token && idToken) {
                    const deviceData = {
                        registration_id: token,
                        type: "web",
                        name: "Web Browser",
                        active: true,
                    };
                    saveFcmDeviceToken(idToken, deviceData)
                        .then((res) => {
                            console.log("FCM DEBUG: Device token saved via prompt:", res);
                        })
                        .catch((err) => {
                            console.error("FCM DEBUG: Error saving token via prompt:", err);
                        });
                }
            });

            // Show success notification
            setTimeout(() => {
                new Notification("Notifications Enabled!", {
                    body: "You'll now receive important updates.",
                    icon: "/logo192.png",
                });
            }, 500);
        }
    };

    const handleDeny = () => {
        localStorage.setItem("notification-prompt-shown", "true");
        setIsVisible(false);
    };

    return (
        <Modal
            open={isVisible}
            footer={null}
            centered
            closable={false}
            className="notification-prompt-modal"
            width={340}
            style={{ maxWidth: "calc(100vw - 32px)" }}
        >
            <div className="notification-prompt-content">
                <div className="notification-icon">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
                            fill="#36d66b"
                        />
                    </svg>
                </div>

                <h2>Allow Notifications</h2>
                <p>Stay updated with important alerts and account activities</p>

                <div className="notification-actions">
                    <button className="btn-allow" onClick={handleAllow}>
                        Allow Notifications
                    </button>
                    <button className="btn-deny" onClick={handleDeny}>
                        Not Now
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NotificationPrompt;
